import React from 'react';
import { withInject } from '@piwikpro/platform';
import {
  Text,
  withTranslation,
  Stack,
  Card,
  AutoSavedSwitcherControl,
} from '@piwikpro/ui-components';
import { TrackerSettings, TrackerSettingsAttributes, TrackerSettingsResponse } from '../../../TrackerSettings';
import FailMessage from '../../GlobalAppSettings/FailMessage';

export interface ExcludeUnknownUrlProps {
  settings: TrackerSettingsResponse
  trackerSettings: TrackerSettings
  failed: boolean
  t: (key: string) => string
}

export class ExcludeUnknownUrl extends React.Component<ExcludeUnknownUrlProps> {
  constructor(props: ExcludeUnknownUrlProps) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(values: Partial<TrackerSettingsAttributes>, {
    setErrors,
    setSubmitting,
    setFieldValue,
  }: any) {
    const { trackerSettings, settings } = this.props;

    try {
      await trackerSettings.updateSettings(values);
    } catch (err: any) {
      setErrors(err.errors);
      setFieldValue(
        'exclude_unknown_urls',
        settings.attributes.exclude_unknown_urls,
        false,
      );
    }

    setSubmitting(false);
  }

  render() {
    const { settings, failed, t } = this.props;

    return (
      <Card.Section>
        <Stack wrap verticalAlignment="center">
          <Stack.Item fill>
            <Stack vertical spacing="narrow">
              <Stack.Item>
                <Text as="h2" size={20} weight={700} wrapType="noWrapAndCutText" dataId="Header.medium">{t('apps.details.settings.tracking.exact-match')}</Text>
              </Stack.Item>
              <Stack.Item>
                <Text as="p">{t('apps.details.settings.tracking.exact-match-description')}</Text>
              </Stack.Item>
            </Stack>
          </Stack.Item>
          {!failed && (
            <Stack.Item>
              <AutoSavedSwitcherControl
                id="app-settings-tracking-exclude-unknown-urls"
                initialValue={settings.attributes.exclude_unknown_urls}
                name="exclude_unknown_urls"
                onSubmit={this.handleSubmit}
              />
            </Stack.Item>
          )}
        </Stack>
        {failed && <FailMessage condensed />}
      </Card.Section>
    );
  }
}

export default withInject({
  trackerSettings: 'TrackerSettingsCrate.tracker',
})(withTranslation(['administration'])(ExcludeUnknownUrl as any));
